import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";
import {
  AdditionalExpenseItem,
  EstimatedRepairCategory,
  EstimatedRepairTimeUnit,
} from "../expenses/expenseSettings";

const isEstimatedRepairCategory = (value: unknown): value is EstimatedRepairCategory =>
  value === "body" || value === "mechanical" || value === "safety";

export const parseEstimatedRepairTime = (value: unknown): number | null => {
  if (value == null || value === "") return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const parseEstimatedRepairTimeUnit = (
  value: unknown,
): EstimatedRepairTimeUnit =>
  value === "days" || value === "weeks" || value === "hours" ? value : "hours";

export const additionalExpenseItemConverter: FirestoreDataConverter<AdditionalExpenseItem> = {
  toFirestore(item: WithFieldValue<AdditionalExpenseItem>) {
    const data = item as AdditionalExpenseItem;
    return {
      name: typeof data.name === "string" ? data.name : "",
      amount: typeof data.amount === "number" && Number.isFinite(data.amount) ? data.amount : 0,
      category: isEstimatedRepairCategory(data.category) ? data.category : "safety",
      estimated_repair_time: parseEstimatedRepairTime(data.estimated_repair_time),
      estimated_repair_time_unit: parseEstimatedRepairTimeUnit(data.estimated_repair_time_unit),
      created_at: data.created_at ?? null,
      updated_at: data.updated_at ?? null,
      created_by: data.created_by ?? null,
      updated_by: data.updated_by ?? null,
    };
  },
  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options: SnapshotOptions,
  ): AdditionalExpenseItem {
    const data = snapshot.data(options) as Record<string, unknown>;
    const name = typeof data.name === "string" ? data.name.trim() : "";
    return {
      id: snapshot.id,
      name,
      amount: Number(data.amount) || 0,
      category: isEstimatedRepairCategory(data.category) ? data.category : "safety",
      estimated_repair_time: parseEstimatedRepairTime(data.estimated_repair_time),
      estimated_repair_time_unit: parseEstimatedRepairTimeUnit(data.estimated_repair_time_unit),
      created_at: typeof data.created_at === "string" ? data.created_at : undefined,
      updated_at: typeof data.updated_at === "string" ? data.updated_at : undefined,
      created_by: typeof data.created_by === "string" ? data.created_by : undefined,
      updated_by: typeof data.updated_by === "string" ? data.updated_by : undefined,
    };
  },
};
